import { makeAutoObservable, runInAction } from 'mobx';
import { getOrganizationsDetailsApi } from '../../api/availity/api-availity';

class ProviderStore {
  selectedOrganization = '';

  taxIds = [];

  taxId = '';

  npi = '';

  customerId = '';

  selectedProvider = '';

  constructor() {
    makeAutoObservable(this);
  }

  resetStore() {
    this.selectedOrganization = '';
    this.selectedProvider = '';
    this.taxId = '';
    this.npi = '';
    this.customerId = '';
    this.taxIds = [];
  }

  onSelectedOrganization = async (selectedOrg) => {
    if (selectedOrg) {
      this.taxId = '';
      this.selectedOrganization = selectedOrg;
      this.customerId = selectedOrg.customerId;
      const organizationsDetailsResponse = await getOrganizationsDetailsApi(this.selectedOrganization.id);
      const taxIds = organizationsDetailsResponse.map((taxId) => ({
        id: taxId.id,
        type: taxId.value,
      }));
      runInAction(() => {
        this.taxIds = taxIds;

        if (this.taxIds.length === 1) {
          this.taxId = this.taxIds[0].id;
        }
      });
    } else {
      this.selectedOrganization = '';
      this.customerId = '';
      this.taxIds = [];
      this.taxId = '';
    }
    this.selectedProvider = '';
    this.npi = '';
  };

  setTaxId = (taxId) => {
    this.taxId = taxId || '';
  };

  setNPI = (npi) => {
    this.npi = npi;
  };

  setProvider = (provider) => {
    this.selectedProvider = provider;
    if (provider) {
      this.atypical = provider.atypical;
      this.npi = provider.npi;
    } else {
      this.npi = '';
      this.atypical = false;
    }
  };

  handleChangeProviderStore = (key, value) => {
    if (!key && !value) {
      return;
    }
    this[key] = value;
  };
}

export default new ProviderStore();
